module.exports = __webpack_public_path__ + "img/35052bf.png";